module.exports = __webpack_public_path__ + "static/media/ankitkumar.13f74793.png";